<template>
  <div class="container-fluid p-0 m-0 position-relative" slot-scope="{content}">
    <img :src="image" :alt="alt" class="s301-image">
    <div class="s301-mask"></div>
    <div class="s301-text">
      <div class="">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "S301",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    }
  }
}
</script>

<style scoped>


.s301-image {
  display: block;
  width: 100%;
  height: 480px;
  object-fit: cover;
}

.s301-mask {
  position: absolute;
  bottom: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  transition: .5s ease;
  opacity: 0;
  font-size: 20px;
  padding: 20px;
  text-align: center;
}

.s301-mask {
  opacity: 1;
}

.s301-text {
  position: absolute;
  top: 8px;
  right: 16px;
  height: 100%;
  display: table;
  padding-right: 50px;
}

.s301-text * {
  z-index: 3;
}

.s301-text > div {
  display: table-cell;
  vertical-align: middle;
}
</style>